import { AxiosResponse } from "axios";
import apiClient from "./ApiClient";

export default {
  token(ip: string): Promise<AxiosResponse> {
    return apiClient.post("/auth/token", { ipAddress: ip });
  },
};
